import { gql } from "@apollo/client";

// Une seule page couvre tous les établissements de l'organisation : le
// controller pagine avant de filtrer par rôle, une petite page pourrait donc
// manquer des établissements de l'utilisateur.
export const ADMIN_ESTABLISHMENTS_PAGE_SIZE = 1000;

// Variables de la liste centrale (AdminProvider). Partagées avec les
// mutations qui doivent la relire (useEstablishment.refetchQueries) : pour
// qu'elles ciblent la même entrée de cache, elles doivent rester identiques.
export const buildAdminEstablishmentsVariables = (organizationId) => ({
  organizationId,
  paginationParams: { currentPage: 0, sizePage: ADMIN_ESTABLISHMENTS_PAGE_SIZE },
});

// Source unique de la liste des établissements de l'espace /admin. Aucun
// `withRole` : tous les établissements rattachés à l'utilisateur, quel que
// soit son rôle (les sélections « gérables » / « valides » sont dérivées côté
// client depuis `userRole` et `status`).
export const GET_ADMIN_ESTABLISHMENTS = gql`
  query GetAdminEstablishments(
    $paginationParams: BaseCollection!
    $organizationId: String!
  ) {
    QR_LIST_ESTABLISHMENT(
      paginationParams: $paginationParams
      organizationId: $organizationId
    ) {
      code
      error {
        message
        timestamp
        correlationId
      }
      data {
        totalElements
        totalPages
        currentPage
        content {
          id
          status
          activities
          userRole
          isOwner
          company {
            legalName
          }
        }
      }
    }
  }
`;
